import React from 'react';

export default function ValidationError(props){
  return(
    <p>{props.render}</p>
  )
}